<template>
  <Catalogs
    title="Города"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'TownCatalogAdd'"
    :route-edit="'TownCatalogEdit'"
    :route-view="'TownCatalogView'"
    :route-path="'/town_catalogs'"
    :can-edit="canEditTownCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "TownCatalogs",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getTowns(data);
    },
    canEditTownCatalogs() {
      return this.hasPermission([PERM.CATALOG_TOWN_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Towns/TownCatalogs.vue